import React, { useEffect, useState } from "react";
import "./Registration.css";
import Button from "@mui/material/Button";
import res from "../../../resources";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import axios from "axios";
import moment from "moment";
import momentTz from "moment-timezone";
import { Tooltip } from "@mui/material";
import { Info } from "@mui/icons-material";
import deemedLogo from "../../../resources/assets/logo.png";
import { ValidateLegalName, FormatName } from "pages/bookingModel/services/validationService";

export default function Registration() {
  const navigate = useNavigate();
  // const [country, setCountry] = useState("Sri Lanka");
  const [valuesPass, setValuesPass] = React.useState({
    password: "",
    showPassword: false,
  });
  const [isTermsSelected, setIsTermsSelected] = useState(false);
  // const [slPhone, setSLPhone] = useState("");
  const [intPhone, setIntPhone] = useState("");
  const [districtAllowed, setDistrictAllowed] = useState(false);

  const handleClickShowPassword = () => {
    setValuesPass({ ...valuesPass, showPassword: !valuesPass.showPassword });
  };

  // const handleCountryChange = (e) => {
  //   setCountry(e.target.value);
  // };

  // useEffect(() => {
  //   console.log("Country is update to : ", country);
  //   // validate();
  // }, [country]);

  // can be removed
  // const validateRegisteredUser = async (email, phone) => {
  //   const res = await axios.post(
  //     `${process.env.REACT_APP_BACKEND_URL}user/validate`,
  //     {
  //       email: email,
  //       phoneNumber: phone,
  //     }
  //   );
  //   return res?.data?.data;
  // };

  const validateRegisteredSLUser = async (email, phone) => {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/validate/sluser`,
      {
        email: email,
        phoneNumber: phone,
      },
    );
    return res?.data?.data;
  };

  // const validateRegisteredSLUserByInt = async (email) => {
  //   const res = await axios.post(
  //     `${process.env.REACT_APP_BACKEND_URL}user/validate/sluserbyint`,
  //     {
  //       email: email,
  //     }
  //   );
  //   return res?.data?.data;
  // };

  const validateRegisteredInternationalUser = async (email, phone) => {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/validate/intuser`,
      {
        email: email,
        phoneNumber: phone,
      },
    );
    return res?.data?.data;
  };

  const validate = async (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = "Email is required";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }

    // if (!values.name) {
    //   errors.name = "Name is required";
    // }

const firstNameCheck = ValidateLegalName(values.firstName);
if (firstNameCheck !== true) {
  errors.firstName = `First name: ${firstNameCheck}`;
}

const lastNameCheck = ValidateLegalName(values.lastName);
if (lastNameCheck !== true) {
  errors.lastName = `Last name: ${lastNameCheck}`;
}

    if (!values.password) {
      errors.password = "Password is required";
    }

    // if (!values.country) {
    //   errors.country = "Country is required";
    // }

    // const regex =
    //   /^(0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    // if (!values.phone || values.phone === "") {
    //   errors.phone = "Phone number is required";
    // } else if ((values.phone || values.phone !== "") && !regex.exec(values.phone)) {
    //   setIntPhone(values.phone);
    //   console.log("Phone number is not a sl one");
    // }

    const sriLankanPhoneRegex =
      /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    const internationalPhoneRegex = /^\+[1-9]\d{1,14}$/;

    if (!values.phone || values.phone === "") {
      errors.phone = "Phone number is required";
    }
    if (values.phone) {
      if (sriLankanPhoneRegex.test(values.phone)) {
        // console.log("Sri Lankan phone number");
        setDistrictAllowed(true);
        // if (!values.district || values.district === "") {
        //   errors.district = "District is required";
        // }
      } else if (internationalPhoneRegex.test(values.phone)) {
        // console.log("International phone number");
        setIntPhone(values.phone);
        setDistrictAllowed(false);
      } else {
        errors.phone = "Phone number is invalid";
      }
    }

    if (!values.dob) {
      errors.dob = "Date of Birth is required";
    } else if (new Date(values.dob) >= new Date()) {
      errors.dob = "Invalid Date of Birth";
    }

    if (!values.email) {
      errors.email = "Email is required";
    }

    if (!values.address) {
      errors.address = "Address is required";
    }

    // if (country === "Sri Lanka") {
    if (sriLankanPhoneRegex.exec(values.phone)) {
      // phone number is a sri lankan one
      if (errors.email == null && errors.phone == null) {
        // const userValidation = await validateRegisteredSLUser(
        //   values.email,
        //   values.phone
        // );
        const userValidationForSL = await validateRegisteredSLUser(
          values.email,
          values.phone,
        );

        if (
          userValidationForSL?.isExisting &&
          userValidationForSL.field === "EMAIL"
        ) {
          errors.emailVal = "Email is already registered";
        }

        if (
          userValidationForSL?.isExisting &&
          userValidationForSL.field === "PHONE_NUMBER"
        ) {
          errors.phoneVal = "Phone Number or email is already registered";
        }
      }
    } else if (
      intPhone &&
      values.phone !== "" &&
      internationalPhoneRegex.exec(values.phone)
    ) {
      // console.log("Country validate as International");
      if (errors.email == null) {
        const userValidationForInternational =
          await validateRegisteredInternationalUser(values.email, values.phone);
        // const userValidationForSL = await validateRegisteredSLUserByInt(
        //   values.email
        //   // should be if phone number is not empty
        //   // values.phone
        // );

        if (
          userValidationForInternational?.isExisting &&
          userValidationForInternational.field === "EMAIL"
        ) {
          errors.emailVal = "Email is already registered";
        }

        if (
          userValidationForInternational?.isExisting &&
          userValidationForInternational.field === "PHONE_NUMBER"
        ) {
          errors.phoneVal = "Phone Number or email is already registered";
        }

        // if (
        //   userValidation?.isExisting &&
        //   userValidation.field === "PHONE_NUMBER"
        // ) {
        //   errors.phoneVal = "Phone Number is already registered";
        // }
      }
      return errors;
    }

    // if (country === "Sri Lanka") {
    //   if (!values.district) {
    //     errors.district = "District is required";
    //   }
    // }
    // if (!values.district) {
    //      errors.district = "District is required";
    // }

    if (!isTermsSelected) {
      errors.isTermSelected =
        "Please confirm that you have agreed to the Terms and Conditions !";
    }

    return errors;
  };

  // const sendOtp = async (email, phone) => {
  //   let data = {
  //     emailAddress: email,
  //     phoneNumber: phone,
  //   };
  //   const res = await axios.post(
  //     `${process.env.REACT_APP_BACKEND_URL}user/send-otp`,
  //     data
  //   );
  //   return res?.data?.data;
  // };

  const sendOTPSriLanka = async (phone, email) => {
    let data = {
      email: email,
    };

    if (phone) {
      data.phoneNumber = phone;
    }

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/send-otp/srilanka`,

      data,
    );

    return res?.data?.data;
  };

  const sendOTPInternational = async (email) => {
    let data = {
      email: email,
    };

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}user/send-otp/international`,

      data,
    );

    return res?.data?.data;
  };

  const gotoOtp = async (values) => {
    const data = {
      email: values.email,
      password: values.password,
      phoneNumber: values.phone,
      userType: values.userType,
     name: `${FormatName(values.firstName)} ${FormatName(values.lastName)}`,
      gender: values.gender,
      // country: values.country,
      timezone: momentTz.tz.guess() || localStorage.getItem("Time-Zone"),
      district: values.district,
      address: values.address,
      dob: values.dob,
    };
    // const res = await sendOtp(values.email, values.phone);
    // if (res) {
    //   navigate("/otpScreen", { state: data });
    // } else {
    //   alert("Something went wrong!");
    // }

    // Send OTP based on country

    // const res =
    //   country === "Sri Lanka"
    //     ? await sendOTPSriLanka(values.email, values.phone)
    //     : await sendOTPInternational(values.email);

    // if (res) {
    //   if (country === "Sri Lanka") {
    //     alert(
    //       " Your OTP will send to provided email address and to your phone number"
    //     );
    //   } else {
    //     alert(" Your OTP will send to provided email address");
    //   }

    //   navigate("/otpScreen", { state: data });
    // } else {
    //   alert("Something went wrong!");
    // }

    const sriLankanPhoneRegex =
      /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;

    // Check if the phone number matches the Sri Lankan format
    if (sriLankanPhoneRegex.test(values.phone) && !intPhone) {
      data.phoneNumber = values.phone;
      // console.log(
      //   "Sri Lankan phone number. OTP will be sent to phone number and to the email."
      // );
      alert("OTP will be sent to your phone number and to the email.");

      const res = await sendOTPSriLanka(values.phone, values.email);
      if (res) {
        navigate("/otpScreen", { state: data });
      } else {
        alert("Something went wrong!");
      }

      // international phone number
    } else if (intPhone) {
      // console.log(
      //   "Invalid Sri Lankan phone number. OTP will be sent only to the email."
      // );
      alert("OTP will be sent to your email.");

      const res = await sendOTPInternational(values.email);
      if (res) {
        navigate("/otpScreen", { state: data });
      } else {
        alert("Something went wrong!");
      }
    }
  };

  const handleDistrict = (phoneNumber) => {
    const sriLankanPhoneRegex =
      /^(?:\+94|0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;
    const internationalPhoneRegex = /^\+[1-9]\d{1,14}$/;

    if (phoneNumber) {
      if (sriLankanPhoneRegex.test(phoneNumber)) {
        setDistrictAllowed(true);
      } else if (internationalPhoneRegex.test(phoneNumber)) {
        setDistrictAllowed(false);
      } else {
        setDistrictAllowed(false);
      }
    } else {
      setDistrictAllowed(false);
    }
  };

  return (
    <div className="loginBgDoc2">
      <div className="wrapper-center2">
        <div className="row log_wrapper2">
          <div className="text-white log_left2 ">
            {/* <img
              className="logo-img2"
              src={res.Images.logo.deedmed.default}
              alt="logo"
            /> */}
            <img className="logo-img2" src={deemedLogo} alt="logo" />
            <h4 className="log_saying2">
              A doctor is not a mechanic.
              <br />
              A car doesn't react with a<br />
              mechanic, but a human <br /> being does.
            </h4>
            <h4 className="log_saying_name2">- Randa Haines</h4>
          </div>
          <div className="log_right2 ">
            <div className="log_card2 ">
              <h3 className="welcome_text2">Join us to get Consulting</h3>
              {/* <p className="welcome_des2">
                Lorem ipsum dolor sit cmet,concectetur adipliscing elit.
              </p>
              <div className="social_row">
                <Button
                  variant="contained"
                  className="social_btn2 google"
                  placeholder="Name"
                >
                  <img
                    src={res.Images.icons.google.default}
                    className="social_btn_icon"
                    alt=""
                  />
                  Google
                </Button>
                <Button
                  variant="contained"
                  className="social_btn2 facebook"
                  placeholder="Email"
                >
                  <img
                    src={res.Images.icons.facebook.default}
                    className="social_btn_icon"
                    alt=""
                  />
                  Facebook
                </Button>
              </div>
              <div>
                <p className="log_or2">Or</p>
              </div> */}
              <Formik
                initialValues={{
                  email: "",
                  password: "",
                  firstName: "",
                  lastName: "",
                  gender: "MALE",
                  // country: "",
                  timezone: "",
                  district: "Colombo",
                  dob: "",
                  userType: "PATIENT",
                  address: "",
                  phone: "",
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validate={(values) => validate(values)}
                onSubmit={async (values, { setSubmitting }) => {
                  const errors = await validate(values);
                  if (Object.keys(errors).length === 0) {
                    await gotoOtp(values);
                  }

                  setSubmitting(false);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  /* and other goodies */
                }) => (
                  <form onSubmit={handleSubmit} className="formReg">
                    {/* <div className="select_wrapper">
                        <input
                          type="text"
                          className="reg_input_password"
                          placeholder="Name"
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        ></input>
                      </div> */}

                    <div className="row gap-row">
                      <input
                        type="text"
                        className="reg_input"
                        placeholder="First Name"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      ></input>
                      <input
                        type="text"
                        className="reg_input"
                        placeholder="Last Name"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      ></input>

                    </div>

                      <p
  style={{
    fontSize: "11px",
    color: "#677294",
    margin: "0 0 8px 15px",
    lineHeight: "1.4",
  }}
>
Please enter your real name. It will appear on your prescriptions and health records, and may be required for services such as insurance claims.</p>


                    <div className="row gap columnName-DOB">
                      {/* Name wrapper removed – only DOB remains here */}
                      <div className="select_wrapper">
                        <p
                          style={{
                            marginLeft: "0px",
                            width: "40%",
                            paddingLeft: "15px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Date of Birth
                        </p>
                        <Tooltip title="You can also type your birthday here. Just select and type on yyyy-mm-dd">
                          <input
                            type="date"
                            className="reg_input_date"
                            placeholder="Date of Birth"
                            style={{ width: "60%" }}
                            name="dob"
                            value={values.dob}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            max={moment().format("YYYY-MM-DD")}
                          ></input>
                        </Tooltip>
                      </div>
                    </div>

                    <div className="row gap-row">
                      <div className="select_wrapper">
                        <p
                          style={{
                            marginLeft: "0px",
                            width: "40%",
                            paddingLeft: "15px",
                          }}
                        >
                          Gender
                        </p>
                        <select
                          className="reg_input_select"
                          name="gender"
                          value={values.gender}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                        </select>
                      </div>
                      <Tooltip title="If your mobile number not a Sri Lankan number (Ex: 071XXXXXXX), Enter your mobile number with country code (Ex: +44XXXXXXXXXXX)">
                        <input
                          type="text"
                          className="reg_input"
                          placeholder="Mobile Number"
                          name="phone"
                          value={values.phone}
                          onChange={(e) => {
                            handleChange(e);
                            handleDistrict(e.target.value);
                          }}
                          onBlur={handleBlur}
                        ></input>
                      </Tooltip>

                      {/* --- country --- */}
                      {/* <div className="select_wrapper height-adjust">
                        <p
                          style={{
                            marginLeft: "0px",
                            width: "40%",
                            paddingLeft: "15px",
                          }}
                        >
                          Country
                        </p>
                        <select
                          className="reg_input_select"
                          name="country"
                          value={values.country}
                          onChange={(e) => {
                            handleChange(e);
                            handleCountryChange(e);
                          }}
                          onBlur={handleBlur}
                        >
                          <option value="Sri Lanka">Sri Lanka</option>
                          <option value="Other">Other</option>
                        </select>
                      </div> */}
                    </div>

                    <div className="row gap-row">
                      <Tooltip title="Please make sure Your email is correct">
                        <input
                          type="email"
                          className="reg_input"
                          placeholder="Email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        ></input>
                      </Tooltip>
                      {/* <Tooltip title="Enter your phone number with country code if your country is not Sri Lanka, Ex: +44XXXXXXXXXXX"></Tooltip>
                      <input
                        type="text"
                        className="reg_input"
                        placeholder="Mobile Number"
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      ></input> */}
                    </div>
                    {districtAllowed === true && (
                      <div className="select_wrapper height-adjust">
                        <p
                          style={{
                            marginLeft: "0px",
                            width: "40%",
                            paddingLeft: "15px",
                          }}
                        >
                          District
                        </p>
                        <select
                          className="reg_input_select"
                          name="district"
                          value={values.district}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="Colombo">Colombo</option>
                          <option value="Gampaha">Gampaha</option>
                          <option value="Kalutara">Kalutara</option>
                          <option value="Kandy">Kandy</option>
                          <option value="Matale">Matale</option>
                          <option value="Nuwara Eliya">Nuwara Eliya</option>
                          <option value="Galle">Galle</option>
                          <option value="Matara">Matara</option>
                          <option value="Hambantota">Hambantota</option>
                          <option value="Jaffna">Jaffna</option>
                          <option value="Kilinochchi">Kilinochchi</option>
                          <option value="Mannar">Mannar</option>
                          <option value="Vavuniya">Vavuniya</option>
                          <option value="Mullaitivu">Mullaitivu</option>
                          <option value="Batticaloa">Batticaloa</option>
                          <option value="Ampara">Ampara</option>
                          <option value="Trincomalee">Trincomalee</option>
                          <option value="Kurunegala">Kurunegala</option>
                          <option value="Puttalam">Puttalam</option>
                          <option value="Anuradhapura">Anuradhapura</option>
                          <option value="Polonnaruwa">Polonnaruwa</option>
                          <option value="Badulla">Badulla</option>
                          <option value="Moneragala">Moneragala</option>
                          <option value="Ratnapura">Ratnapura</option>
                          <option value="Kegalle">Kegalle</option>
                        </select>
                      </div>
                    )}

                    <div className="row gap-row">
                      {/* {country === "Sri Lanka" && ( */}

                      <div className="row">
                        <div
                          className=" reg_password_wrapper"
                          style={{ width: "100%" }}
                        >
                          <input
                            type="text"
                            className="reg_input_password"
                            placeholder="Address"
                            name="address"
                            value={values.address}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          ></input>
                        </div>
                      </div>
                      {/* )} */}
                    </div>

                    <div className="row column gap-row">
                      <div
                        className=" reg_password_wrapper"
                        style={{ width: "100%" }}
                      >
                        <Tooltip title="Please remember your password">
                          <input
                            type={valuesPass.showPassword ? "text" : "password"}
                            className="reg_input_password"
                            placeholder="Password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          ></input>
                        </Tooltip>
                        <Button
                          // type="contained"
                          onClick={() => handleClickShowPassword()}
                          style={{ padding: "0" }}
                        >
                          {valuesPass.showPassword ? (
                            <img
                              src={res.Images.icons.eyeOff.default}
                              style={{ width: "15px", color: "#677294;" }}
                              alt=""
                            />
                          ) : (
                            <img
                              src={res.Images.icons.eye.default}
                              style={{ width: "15px", color: "#677294;" }}
                              alt=""
                            />
                          )}
                        </Button>
                      </div>
                      <div className="select_wrapper">
                        <p
                          style={{
                            marginLeft: "0px",
                            width: "40%",
                            paddingLeft: "15px",
                          }}
                        >
                          Are You
                        </p>
                        <Tooltip title="More features will come in soon">
                          <select
                            className="reg_input_select"
                            name="userType"
                            value={values.userType}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="PATIENT">Patient</option>
                            {/* <option value="GUARDIAN">Guardian</option> */}
                          </select>
                        </Tooltip>
                      </div>
                    </div>
                    <div className="text-center ">
                      {/* errors */}
                      {/* Displaying validation errors */}
                      {Object.keys(errors).map((key) => (
                        <span
                          key={key}
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "10px",
                          }}
                        >
                          {errors[key]}

                          <br />
                        </span>
                      ))}
                      {/* {errors.email && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "10px",
                          }}
                        >
                          A valid email address is required
                          <br />
                        </span>
                      )}
                      {errors?.emailVal && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "10px",
                          }}
                        >
                          Email address already exists
                          <br />
                        </span>
                      )}
                      {errors?.phoneVal && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "10px",
                          }}
                        >
                          Phone Number is already registered
                          <br />
                        </span>
                      )}
                      {errors.name && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          Name is required
                          <br />
                        </span>
                      )}
                      {errors.password && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          Password is required
                          <br />
                        </span>
                      )}
                      {errors.dob && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          {errors.dob}
                          <br />
                        </span>
                      )}
                      {errors.country && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          Country is required
                          <br />
                        </span>
                      )}
                      {errors.district && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          District is required
                          <br />
                        </span>
                      )}
                      {errors.address && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          Address is required
                          <br />
                        </span>
                      )}
                      {errors.phone && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          {errors.phone}
                          <br />
                        </span>
                      )}
                      {errors.isTermSelected && (
                        <span
                          style={{
                            color: "red",
                            fontSize: "12px",
                            fontWeight: "500",
                            marginBottom: "20px",
                          }}
                        >
                          Please confirm that you have agreed to the Terms and
                          Conditions ! <br />
                        </span>
                      )} */}
                    </div>

                    <div className="row justify-content-center align-items-center">
                      <input
                        type="checkbox"
                        className="checkbox-round"
                        // id={keyName}
                        // value={addMorePres.id}
                        onChange={(e) => setIsTermsSelected(e.target.checked)}
                        // onClick={handleselectedName}
                      />
                      <p style={{ fontSize: "10px", color: "#677294" }}>
                        I agree with the{" "}
                        <a
                          style={{ textDecoration: "none", color: "#265ED7" }}
                          href="https://deedmed.lk/term-conditions/"
                          target="_blank"
                        >
                          Terms of Service
                        </a>{" "}
                        and{" "}
                        <a
                          style={{ textDecoration: "none", color: "#265ED7" }}
                          href="https://deedmed.lk/privacy-policy/"
                          target="_blank"
                        >
                          Privacy Policy
                        </a>
                      </p>
                    </div>
                    <div className="row justify-content-center">
                      <Button
                        variant="contained"
                        className="payBtn reg_submit_btn"
                        // className="btn log_btn2"
                        // color="primary"
                        type="submit"
                        // onClick={(e)=>e.preventDefault()}
                        // disabled={isSubmitting}
                      >
                        Sign Up
                      </Button>
                    </div>
                  </form>
                )}
              </Formik>
              <div className="row justify-content-center">
                <Link to={"/login"} style={{ textDecoration: "none" }}>
                  {" "}
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#265ED7",
                      fontWeight: "600",
                    }}
                  >
                    Have an account? Log in
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
